module.exports = __webpack_public_path__ + "img/15000dou.77ff527b.png";